var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.mediaLgMatches)?[_c('PricingTariffsSlider',_vm._b({},'PricingTariffsSlider',_vm.pricingTariffsOptions,false))]:[_c('PricingTariffsList',_vm._b({},'PricingTariffsList',_vm.pricingTariffsOptions,false))]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }